import Confirm from 'assets/components/page/templates/Confirm';
import ThemeConfirmDefault from 'assets/components/page/templates/themes/Theme.Confirm.Default';
import { getLocales } from 'assets/locales/Locale';
import React from 'react';
import { useClaimEmailTemplateProvider } from '../ClaimEmailTemplate.Hooks';

export default function ClaimEmailTemplateDelete() {
  const { lang } = getLocales();
  const { deleteApi, selected, pageRouter } = useClaimEmailTemplateProvider();

  return (
    <Confirm
      data={selected}
      onConfirm={({ id }) => deleteApi.execute(id)}
      onClose={pageRouter.updateParams}
      actionName={lang.delete}
      itemName={selected.name}
      confirmationType="nextButton"
      subcomponents={ThemeConfirmDefault}
    />
  );
}
